export default {
  title: 'General info',
  subtitle: 'Please enter the name and email of a new employee',
  created: 'Created: ',
  activity: 'Last login: ',
  noActivity: 'Last login: -',
  userName: 'Username: ',
  phoneNumber: 'Phone number: ',
  approvalDateTime: 'Solera approval date: ',
  noApprovalDateTime: 'Solera approval date: -',
  nextBillingDate: 'Next billing date: ',
  noNextBillingDate: 'Next billing date: -',
  accountNumber: 'Account number ',
  placeholder: {
    firstName: 'First name*',
    middleName: 'Middle name',
    lastName: 'Last name*',
    email: 'Email*',
    custodianType: 'Custodian*',
    profileType: 'Profile type*',
    etzFee: 'ETZ fee (transaction share)*',
    annualFee: 'Annual Fee*',
    nextBillingDate: 'Next billing date',
    custodyFeePercentage: '% annual custody/maintenance fee',
    custodyFeeAbsolute: '$ annual custody/maintenance fee',
    employerName: 'Employer',
  },
  custodyFeeTitle: 'Custody/maintenance fee',
};
